export const config = () => ({
    functions: {
        domainUrl: 'https://www.clearandfizzy.com',
        dataUrl: '/.netlify/functions/data',
    },
    header: {
        title: 'Gareth Price',
        tagline: 'London based / NodeJS / Typescript / PHP / Open AI developer',
    },
    exampleCode: {
        title: 'Example Code',
        codeLinks: [
            {
                label: "Functional Factory/Builder Pattern (Node/Typescript)",
                url: "https://bitbucket.org/clearandfizzy/functional-factory-builder-pattern/src/main/"
            },
            {
                label: "Todo List (ReactJS/Typescript)",
                url: "https://bitbucket.org/clearandfizzy/test-frontend-developer/src"
            },

        ]
    },
    personProjects: {
        title: 'Personal Projects',
        projectsLinks: [
            {
                label: "NextJS E-commerce site",
                url: "https://surfshack.vercel.app/"
            },
            {
                label: "ReactJS Todo List",
                url: "https://clearandfizzy-todo.netlify.app/"
            },
            {
                label: "React + Youtube/Spotify Api integration",
                url: "https://spotify-youtube-import.netlify.app/"
            },
            {
                label: "API - Express server",
                url: "https://bitbucket.org/clearandfizzy/netlify-express/src/main/"
            },
            {
                label: "API - Headless Laravel + ReactJS",
                url: "https://bitbucket.org/clearandfizzy/headless-laravel-example/src/main/"
            },
            {
                label: "Functional Programming Factory Design Pattern",
                url: "https://bitbucket.org/clearandfizzy/functional-factory-builder-pattern/src/main/"
            },
            {
                label: "Open AI - Chatbot",
                url: "https://echobud.netlify.app/"
            },
            {
                label: "Blog",
                url: "/blog"
            },
            {
                label: "RxJS",
                url: "https://clearandfizzy-rxjs.netlify.app/"
            },
            {
                label: "Lodash",
                url: "https://clearandfizzy-lodash.netlify.app/"
            },
            {
                label: "HTML5",
                url: "https://clearandfizzy-html5.netlify.app/"
            },
            {
                label: "MobX",
                url: "https://clearandfizzy-mobx.netlify.app/"
            },
            {
                label: "Bitcoin Tracker – Chrome Extension",
                url: "https://chrome.google.com/webstore/detail/bitcoin-tracker/jbhbjeaollnekdnlkhoajhjfemfmnafp"
            },
        ]
    },
    "footer": {
        "title": "Get In Touch",
        "links": [
            {
                label: "Portfolio",
                url: "https://www.clearandfizzy.com",
                link_label: 'www.clearandfizzy.com'
            },
            {
                label: "LinkedIn",
                url: "https://www.linkedin.com/in/garethpricelondon",
                link_label: 'linkedin.com/garethpricelondon'
            },
            {
                label: "Twitter",
                url: "https://twitter.com/garethprice",
                link_label: "twitter.com/garethprice"
            },
            {
                label: "YouTube",
                url: "https://www.youtube.com/@ClearandfizzyLimited",
                link_label: "youtube.com/@ClearandfizzyLimited"
            }
        ],
    }
})